import { useCallback } from 'react';
import { useGetIdentity } from 'react-admin';
import { supabase } from '../providers/supabase/supabase';

export type DiscountCsvRow = {
    AIP?: string;
    aip?: string;
    State?: string;
    state?: string;
    has_discount?: string | boolean;
    discount?: string | number;
    discount_deadline?: string;
    premium_deadline?: string;
    notes?: string;
    Notes?: string;
    excluded_crops?: string;
    excluded_products?: string;
};

function normalizeRow(raw: DiscountCsvRow) {
    const aip = (raw.AIP ?? raw.aip ?? '').toString().trim();
    const state = (raw.State ?? raw.state ?? '').toString().trim();

    const hasDiscountRaw = (raw.has_discount ?? '')
        .toString()
        .toLowerCase()
        .trim();
    const has_discount = ['yes', 'true', '1'].includes(hasDiscountRaw);

    const discountRaw = raw.discount;
    const discount =
        discountRaw != null && discountRaw !== '' ? Number(discountRaw) : null;

    const discount_deadline = (raw.discount_deadline ?? '').toString().trim();
    const premium_deadline = (raw.premium_deadline ?? '').toString().trim();
    const notes = (raw.Notes ?? raw.notes ?? '').toString().trim();

    const excludedCropsRaw = (raw.excluded_crops ?? '').toString().trim();
    const excluded_crops = excludedCropsRaw
        ? excludedCropsRaw
              .split(',')
              .map(c => c.trim())
              .filter(Boolean)
        : [];

    const excludedProductsRaw = (raw.excluded_products ?? '').toString().trim();
    const excluded_products = excludedProductsRaw
        ? excludedProductsRaw
              .split(',')
              .map(c => c.trim())
              .filter(Boolean)
        : [];

    return {
        aip,
        state,
        has_discount,
        discount,
        discount_deadline: discount_deadline || null,
        premium_deadline: premium_deadline || null,
        notes: notes || null,
        excluded_crops,
        excluded_products,
    };
}

export function useDiscountImport() {
    const user = useGetIdentity();

    const processBatch = useCallback(
        async (batch: DiscountCsvRow[]) => {
            const rows = batch.map(normalizeRow).filter(r => r.aip && r.state);

            if (rows.length === 0) return;

            const { error } = await supabase
                .from('discount_manager')
                .insert(rows);

            if (error) {
                console.error('Discount import batch error:', error);
                throw error;
            }
        },
        [user?.identity?.id]
    );

    return { processBatch };
}
